var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.333 80.7053C286.815 45.7859 355.424 27.4022 425.262 27.4018C495.101 27.4014 563.71 45.7845 624.192 80.7032C684.675 115.622 734.9 165.846 769.82 226.328C804.741 286.809 823.125 355.417 823.127 425.256L425.264 425.264L226.333 80.7053Z",
    fill: "url(#paint0_linear_61_28)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.334 769.824C165.852 734.904 115.627 684.68 80.7069 624.198C45.7872 563.716 27.4032 495.107 27.4024 425.269C27.4017 355.43 45.7843 286.822 80.7028 226.339C115.621 165.856 165.845 115.63 226.326 80.7099L425.265 425.265L226.334 769.824Z",
    fill: "url(#paint1_linear_61_28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.127 425.264C823.127 495.103 804.744 563.711 769.825 624.193C734.906 684.676 684.681 734.901 624.2 769.821C563.718 804.741 495.11 823.125 425.271 823.126C355.432 823.127 286.824 804.745 226.341 769.827L425.265 425.264L823.127 425.264Z",
    fill: "url(#paint2_linear_61_28)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_28",
    x1: 735.276,
    y1: 408.578,
    x2: 270.276,
    y2: 160.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_28",
    x1: 330.554,
    y1: 654.893,
    x2: 145.962,
    y2: 520.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_28",
    x1: 424.776,
    y1: 774.078,
    x2: 699.776,
    y2: 425.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors3);
export default __webpack_public_path__ + "static/media/sectors-3.d2ad61e36c2ce400bacf52e3152447fb.svg";
export { ForwardRef as ReactComponent };